export default {
  LOGIN_EMAIL: 'johnny.john373@gmail.com',
  LOGIN_ORDERS: ['1018', '1017', '1016', '1015', '1014', '1013', '1012']
};
